import MembershipPlansScreen from '@/screens/join-premium/MembershipPlansScreen'

export default function () {
  return <MembershipPlansScreen />
}
